import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import PageShell from './PageShell';
import { Mail, Lock, User, ArrowRight } from 'lucide-react';
import { useUserAuth } from '../context/UserAuthContext';
import { useToast } from '../hooks/use-toast';

export function Login() {
  const { login } = useUserAuth();
  const { toast } = useToast();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get('redirect') || '/account';
  const [f, setF] = useState({ email: '', password: '' });
  const [err, setErr] = useState(''); const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(''); setLoading(true);
    try { await login(f.email, f.password); toast({ title: 'Hoş geldiniz!' }); nav(redirect); }
    catch (er) { setErr(er?.response?.data?.detail || 'Giriş başarısız'); }
    finally { setLoading(false); }
  };

  return (
    <PageShell eyebrow="HESABIM" title={<><span className="text-white">Giriş </span><span className="gold-text">Yap</span></>} subtitle="Hesabınıza giriş yaparak siparişlerinizi takip edin.">
      <section className="pb-24">
        <div className="max-w-md mx-auto px-6">
          <form onSubmit={submit} className="rounded-3xl border border-white/10 bg-gradient-to-b from-[#111015] to-[#0a090c] p-6 md:p-8 space-y-5">
            <label className="block"><span className="text-xs tracking-widest text-white/50">E-POSTA</span>
              <div className="relative mt-2"><Mail className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
                <input required type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="w-full h-12 pl-11 pr-4 rounded-full bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60" /></div></label>
            <label className="block"><span className="text-xs tracking-widest text-white/50">PAROLA</span>
              <div className="relative mt-2"><Lock className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
                <input required type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="w-full h-12 pl-11 pr-4 rounded-full bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60" /></div></label>
            {err && <div className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-4 py-2">{err}</div>}
            <button disabled={loading} className="w-full btn-gold h-12 rounded-full inline-flex items-center justify-center gap-2 text-sm font-extrabold tracking-widest disabled:opacity-60">{loading ? 'GİRİŞ YAPILIYOR...' : 'GİRİŞ YAP'} <ArrowRight className="w-4 h-4" /></button>
            <div className="text-center text-sm text-white/60">Hesabınız yok mu? <Link to="/register" className="text-[#f4d896] font-semibold">Kayıt Ol</Link></div>
          </form>
        </div>
      </section>
    </PageShell>
  );
}

export function Register() {
  const { register } = useUserAuth();
  const { toast } = useToast();
  const nav = useNavigate();
  const [f, setF] = useState({ name: '', email: '', password: '' });
  const [err, setErr] = useState(''); const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(''); setLoading(true);
    try { await register(f.name, f.email, f.password); toast({ title: 'Hesap oluşturuldu!' }); nav('/account'); }
    catch (er) { setErr(er?.response?.data?.detail || 'Kayıt başarısız'); }
    finally { setLoading(false); }
  };

  return (
    <PageShell eyebrow="YENİ HESAP" title={<><span className="text-white">Kayıt </span><span className="gold-text">Ol…</span></>} subtitle="Aegis Studios topluluguna katılın.">
      <section className="pb-24">
        <div className="max-w-md mx-auto px-6">
          <form onSubmit={submit} className="rounded-3xl border border-white/10 bg-gradient-to-b from-[#111015] to-[#0a090c] p-6 md:p-8 space-y-5">
            <label className="block"><span className="text-xs tracking-widest text-white/50">AD SOYAD</span>
              <div className="relative mt-2"><User className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
                <input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="w-full h-12 pl-11 pr-4 rounded-full bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60" /></div></label>
            <label className="block"><span className="text-xs tracking-widest text-white/50">E-POSTA</span>
              <div className="relative mt-2"><Mail className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
                <input required type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="w-full h-12 pl-11 pr-4 rounded-full bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60" /></div></label>
            <label className="block"><span className="text-xs tracking-widest text-white/50">PAROLA</span>
              <div className="relative mt-2"><Lock className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
                <input required minLength={6} type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="w-full h-12 pl-11 pr-4 rounded-full bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#e4b44e]/60" /></div></label>
            {err && <div className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-4 py-2">{err}</div>}
            <button disabled={loading} className="w-full btn-gold h-12 rounded-full inline-flex items-center justify-center gap-2 text-sm font-extrabold tracking-widest disabled:opacity-60">{loading ? 'KAYIT OLUYOR...' : 'KAYIT OL'} <ArrowRight className="w-4 h-4" /></button>
            <div className="text-center text-sm text-white/60">Hesabınız var mı? <Link to="/login" className="text-[#f4d896] font-semibold">Giriş Yap</Link></div>
          </form>
        </div>
      </section>
    </PageShell>
  );
}
